import React, {Component} from "react";
import {types, PropTypes, warning, tutils, transitions} from "Subschema";
import styles from "./FloatingLabel.less";
import Transition from "react-addons-css-transition-group";
import _get from "lodash/Object/get";

export default class FloatingLabel extends Component {

    static displayName = 'FloatingLabel';

    static propTypes = {
        path: PropTypes.path,
        value: PropTypes.value,
        error: PropTypes.errors,
        Content: PropTypes.injectClass,
        style: PropTypes.style,
        label: PropTypes.any,
        title: PropTypes.title,
        active: PropTypes.bool,
        className: PropTypes.string,
        isSelect: PropTypes.bool,
        disabled: PropTypes.bool,
        autoFocus: PropTypes.bool
    };

    static injectedProps = {
        style: "FloatingLabel",
        transition: {
            transition: "rollUp",
            on: ["enter", "appear", "leave"]
        }
    };

    static defaultProps = {
        Content: types.Content,
        noErrorMessage: false,
        noHelpMessage: false,
        contentType: 'Content',
        active: false,
        autoFocus: false
    };

    state = {
        hasFocus: this.props.active || this.props.error && this.props.autoFocus,
        hasError: !!this.props.error,
        error: this.props.error,
        forceFocus: false
    };

    componentWillReceiveProps(props) {
        var newState = {
            hasValue: !!(props.value || props.input),
            hasError: !!props.error,
            error: props.error
        };
        if (!this.state.hasFocus && props.error !== this.props.error && props.autoFocus) {
            newState.forceFocus = true;
        }
        this.setState(newState)
    }

    handleFocus = (e)=> {
        if (this.props.isDisabled) {
            return;
        }
        this.setState({hasFocus: true, forceFocus: false});
    };

    handleBlur = (e)=> {

        if (this.props.active || this.props.disabled) {
            return;
        }
        this.setState({hasFocus: false, forceFocus: false});
    };

    handleChange = (e)=> {

        if (this.props.disabled) {
            return;
        }
        var value = e && e.target && e.target.value;
        this.setState({
            hasValue: !(value == null || value == '')
        });

    };
    handleSelect = (e)=> {
        this.setState({hasValue: true});
    };
    handleValid = (isValid)=> {
        this.setState({isValid});
    };

    /*** end of handlers **/

    createLabel(label, opts) {
        if (label === false || label == '') {
            return null;
        }

        if (typeof label === 'string') {
            label = {
                content: label
            }
        }
        if (!label.type) label.type = 'label';
        if (!label.htmlFor) label.htmlFor = opts.id;
        if (!label.className) label.className = styles.labelContent;
        const Content = this.props.Content;
        return <Content  content={label}/>
    }

    renderError(error) {

        var errorId = this.props.id + '-help';

        if (error.length == 1 && (error[0].level !== 'HINT' || !this.state.hasFocus)) {
            const __html = error[0].message;
            return <div key="error-one" id={errorId} dangerouslySetInnerHTML={{__html}}></div>;
        }
        return <ul key="error" className={styles.hasMessages}>{error.map((v, i)=><li
            key={`error-${i}`}>{v.message}</li>)}</ul>
    }

    renderTransitionInternal(messages) {

        return <span className={messages ? styles.hasGroup : styles.hasGroup}>
                <div key="error" className={styles.hasMessage}>{this.renderError(messages)}</div>
        </span>
    }

    _renderErrorsOrHints(messages) {
        const willNotRender = !messages || this.props.noErrorMessage == true || (!this.state.hasFocus && !this.state.forceFocus);
        return <Transition transitionAppearTimeout={500} transitionLeaveTimeout={500} transitionAppearTimeout={500}
                           transitionName={{
                enter:styles.rollDownEnter,
                enterActive:styles.rollDownEnterActive,
                appear:styles.rollDownEnter,
                appearActive:styles.rollDownEnterActive,
                leave:styles.rollDownEnter,
                leaveActive:styles.rollDownEnterActive,

        }}>
            { willNotRender ?
                <span className="noErrorsOrHints"
                      key="no-errors-or-hints"/> : this.renderTransitionInternal(messages)}
        </Transition>

    }

    renderErrorsOrHints(messages) {
		const isServer = typeof window === "undefined" && typeof document === "undefined";
        const willNotRender = !messages || this.props.noErrorMessage == true || (!isServer && !this.state.hasFocus && !this.state.forceFocus);
        return willNotRender ?
            <span className="noErrorsOrHints"
                  key="no-errors-or-hints"/> : this.renderTransitionInternal(messages)

    }

    normalize(error, help) {
        if ((error == null || error.length == 0) && !help) {
            return {};
        }
        if (error) {
            error = error[this.props.path];
        }
        var that = this;
        const {hints, errors, success} = error.reduce(function (obj, val) {
            if (that.state.hasFocus && val.level === 'HINT') {
                (obj.hints || (obj.hints = [])).push(val);
            } else if (val.type === 'success') {
                obj.success = true;
            } else {
                (obj.errors || (obj.errors = [])).push(val);
            }
            return obj;
        }, {});

        if (success) {
            return {success};
        }
        if (errors) {
            return {errors};
        }
        if (hints) {
            return {hints};
        }

        if (help) {
            return {hints: [{message: help, level: 'HINT'}]};
        }
    }

    firefoxSelectShim() {
      const isFirefox = typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.indexOf("Firefox") > -1;
      const isSelectComponent = _get(this.props, "children.type.Clazz.displayName") === "Select";

      return {
        handleOnKeyUp: () => {
          return this.onKeyUpCount === 0 ? ++this.onKeyUpCount : this.setState({hasValue: true});
        },
        onKeyUpCallback: () => {
          if (isFirefox && isSelectComponent) {
            this.onKeyUpCount = 0;
            return { onKeyUp: this.firefoxSelectShim().handleOnKeyUp }
          } else {
            return {}
          }
        },
        addHasValueStyle: () => {
          const { hasValue } = this.state;
          return hasValue && isFirefox && isSelectComponent;
        },
      }
    }

    render() {
        var {label, active, title, path, disabled, isSelect, noErrorMessage, name, noHelpMessage, help, error, value, placeholder, containerClassName, fieldClass, children, ...restOfProps} = this.props;
        var props = children.props;
        var hasValue = !!value;
        const {hints, errors, success} = this.normalize(error, help);
        var className = [
            styles.group, (containerClassName || fieldClass || ''),
            restOfProps.className,
            (this.state.hasFocus || this.state.forceFocus) ? styles.hasFocus : styles['noFocus'],
            (hasValue || this.firefoxSelectShim().addHasValueStyle()) ? styles['hasValue'] : styles['noValue'],
            hints ? styles.hasHelp : '',
            errors ? styles.hasError : '',
            props.disabled ? styles['isDisabled'] : '',
            isSelect ? styles.select : ''
        ];

        const isEmailInput = props.path === "paypalAccountData.email";

        return <div className={className.join(' ')} disabled={disabled}>
            <div className={styles.inner}>
                {this.renderErrorsOrHints(errors || hints)}
                <div className={styles.wrapping}>

                    <div className={`${styles.label} ${this.state.animating ? 'animating' : ''}`}
                         onFocus={this.handleFocus}
                         onSelect={this.handleSelect}
                         onBlur={this.handleBlur}
                         {...this.firefoxSelectShim().onKeyUpCallback()}>
                        {this.createLabel(title, restOfProps) }
                        { isEmailInput ? React.cloneElement(children, {type:"email"}) : children }
                        {errors ?
                            <i className={styles.errorIcon}/> : hasValue && props.successClass && success ? <i className={styles[`${props.successClass}`]}/> : null}
                    </div>
                </div>
            </div>
        </div>

    }
}



/** WEBPACK FOOTER **
 ** ./src/labels/FloatingLabel.jsx
 **/